import { css } from 'styled-components';
import { breakpointsMap } from '@oneaudi/unified-web-alpha-common';
export const getResponsiveStyles = (styles) => {
    const mediaQueries = {};
    Object.entries(styles).forEach(([property, value]) => {
        if (typeof value !== 'object' || value === null) {
            mediaQueries['default'] = mediaQueries['default'] || [];
            mediaQueries['default'].push(`${property}: ${value};`);
        }
        else {
            Object.entries(value).forEach(([key, val]) => {
                const breakpoint = key === 'default'
                    ? 'default'
                    : breakpointsMap[key];
                if (!mediaQueries[breakpoint]) {
                    mediaQueries[breakpoint] = [];
                }
                mediaQueries[breakpoint]?.push(`${property}: ${val};`);
            });
        }
    });
    return Object.entries(mediaQueries).map(([breakpoint, rules]) => {
        if (breakpoint === 'default') {
            return rules.join(' ');
        }
        return css `
      @media (min-width: ${breakpoint}) {
        ${rules.join(' ')}
      }
    `;
    });
};
//# sourceMappingURL=get-responsive-styles.js.map